.tag {
  display: inline-flex;
  height: 24px;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  border-radius: 12px;

  color: var(--strong-on-inverse);

  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
}
